export default __webpack_public_path__ + "static/media/logo-negro.5772598b.svg";